import { tLogger } from "../logging/logging.client";
import type { SwLogMessage } from "../logging/logging.worker";

const handleServiceWorkerMessage = (event: MessageEvent) => {
  const message = event.data;

  if (message?.type === "LOG_TO_DATADOG") {
    const { level, message: logMessage, context } = message as SwLogMessage;
    tLogger[level](logMessage, { context });
  }
};

export const setupSwLogForwarding = () => {
  if ("serviceWorker" in window.navigator) {
    window.navigator.serviceWorker.addEventListener(
      "message",
      handleServiceWorkerMessage,
    );
  }
};
